<div *ngIf="exist;else attente"></div>
<ng-template #attente>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div class="displayFlex">
    <div [ngStyle]="{'width': (showDocEchange ? '70%' : '100%')}" *ngIf="showTabEchange">
        <!-- <app-avt-listes
            #listeEchangesComponen
            [showFilter]="false"
            [heightTable]="heightTable" 
            [dataSourceBrut]="datasourceEchanges" 
            [displayedColumnsBrut]="columnsEchanges" 
            [listBtn]="listBtnEchanges" 
            (btnTable)="clickBtnHeat($event)" 
            >
        </app-avt-listes> -->
        <app-liste
                    #listeEchangesComponen
                    [showSort]="true"
                    [showFilter]="true"
                    [maxHeight]="heightTable" 
                    [dataSource]="datasourceEchanges"
                    [listBtn]="listBtnEchanges" 
                    [columns] = "columnsEchanges"
                    (output)="actionEchange($event)">
                </app-liste>
    </div>
    <div style="width: 30%;" *ngIf="showDocEchange">
        <app-show-tree-doc [showAllDocument]='false' [File_Groupe]="'echange'" [param_code]="CRMActivity_Id" [File_Type]="type" [typeTrs]="disabled? '3' : '2'"></app-show-tree-doc>
    </div>
</div>

